import { Component, inject } from '@angular/core';
import { PersonService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  PersonCreateDto,
  PersonDto,
  PersonExcelDownloadDto,
  PersonUpdateDto,
} from 'orchestrator';
import { PERSON_CONFIG, PERSON_FIELDS } from './person.config';
import { BaseHierarchicalCrudComponent, GenericForm, ZnHierarchicalViewComponent } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-person',
  imports: [
    CommonModule,
    GenericForm,
    ZnHierarchicalViewComponent,
  ],
  providers: [ListService, PersonService, ConfirmationService],
  templateUrl: './person.html',
  styleUrl: './person.scss',
})
export class Person extends BaseHierarchicalCrudComponent<
  PersonDto,
  PersonCreateDto,
  PersonUpdateDto,
  PersonExcelDownloadDto
> {
  service = inject(PersonService);
  config = PERSON_CONFIG;
  fields = PERSON_FIELDS;

  protected prepareUpdateDto(data: any, selected: PersonDto): PersonUpdateDto {
    return {
      name: data.name,
      code: data.code,
      isActive: data.isActive,
      deactivationReasonId: data.deactivationReasonId,
      deactivationDate: data.deactivationDate,
      internalOrderId: data.internalOrderId,
      notes: data.notes,
      personCategoryId: data.personCategoryId,
      lastName: data.lastName,
      identityNumber: data.identityNumber,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Person';
  }
}
